var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackPencel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 15.1255C3.76675 15.1255 3.375 14.7337 3.375 14.2505L3.375 10.2359C3.375 10.0019 3.4687 9.77771 3.63519 9.61331L11.4685 1.87789C11.8108 1.53984 12.3619 1.54158 12.7021 1.88177L16.6187 5.79844C16.9589 6.13863 16.9606 6.68965 16.6226 7.03197L8.88718 14.8653C8.72278 15.0318 8.49856 15.1255 8.26458 15.1255L4.25 15.1255ZM5.125 13.3755L7.89892 13.3755L14.7664 6.42103L12.0795 3.73404L5.125 10.6016L5.125 13.3755Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.625 17.5C1.625 17.0168 2.01675 16.625 2.5 16.625H17.5C17.9832 16.625 18.375 17.0168 18.375 17.5C18.375 17.9832 17.9832 18.375 17.5 18.375H2.5C2.01675 18.375 1.625 17.9832 1.625 17.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0078 9.24525L9.25781 5.49525L10.4952 4.25781L14.2453 8.00781L13.0078 9.24525Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPencel);
export default __webpack_public_path__ + "static/media/BlackPencel.7b4be3bc8831953023a685fd5c4b4afe.svg";
export { ForwardRef as ReactComponent };